module.exports = __webpack_public_path__ + "assets/img/purpose.1d2bdb84.jpg";